import { Tree, Divider, Space, Button, message, Checkbox, Tooltip, Popover, Badge, Alert, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { EditFilled, DeleteFilled, EditOutlined, DisconnectOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { apiCall } from "../../utils/Api";
import MenuEdit from "../../admin/Menu/MenuEdit";
import ContentList from "../../globals/organize/ContentList";
import { PlusIcon, ClockIcon, FilterIcon, EyeIcon, EyeSlashIcon } from "../../admin/Icons"
import { blue_color, green_color, orange_color, purple_color, red_color, tt_menu_filter, tt_not_activated } from "../../utils/Utils";
import PageRow from "./PageRow";
import Overlay from "../Overlay";
import GlobalContent from "./GlobalContent";
import TrashedMenus from "./TrashedMenus";

export default function PageList(props) {

    const { selected = "", setSelected = () => { }, menus = [], setMenus = () => { }, setToOpenPage = () => { }, page = { id: 0 }, setPage = () => { }, content = [], setContent = () => { }, setOpen = () => { } } = props;

    const [selectEdit, setSelectEdit] = useState({})
    const [visible, setVisible] = useState(false);
    const [filters, setFilters] = useState({ hidden: false, test: false, visible: false });
    const [highlight, setHighlight] = useState(false)
    const drawIcon = () => {
        return false;
    }

    const openEdit = (_node) => {
        setSelectEdit(_node);
        setVisible(true);
    }

    const drawTools = (_node) => {
        return (
            <>
                <div style={{ "float": "right", "display": "inline-block" }}>
                    <EditOutlined onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        openEdit(_node);
                    }} style={{ "fontSize": "10px", "color": "#999", "padding": "1px 5px", "cursor": "pointer" }} />
                </div>
            </>
        )
    }


    const updateMenu = (_nav = [], _dragged_item_id, _og_nav) => {

        // 
        let _menu_item = false;
        // flatten the array
        let _n = [];

        let _index = 0;
        _nav.forEach(itm => {

            let obj = {
                id: itm.id,
                name: itm.name,
                parent_id: null,
                visibility: itm.visibility,
                new_tab: itm.new_tab,
                order: _index,
                url: itm.url,
                v1_page_id: itm.v1_page_id,
                builtin: itm.builtin
            }

            if (itm.id === _dragged_item_id) {
                _menu_item = obj;
            }

            let _chindex = 0;
            itm.children.forEach(ch => {

                let _cobj = {
                    id: ch.id,
                    name: ch.name,
                    parent_id: itm.id,
                    visibility: ch.visibility,
                    new_tab: ch.new_tab,
                    order: _chindex,
                    url: ch.url,
                    v1_page_id: ch.v1_page_id,
                    builtin: ch.builtin
                }

                if (ch.id === _dragged_item_id) {
                    _menu_item = _cobj;
                }

                _chindex++;
                _n.push(_cobj);
            })


            _index++;
            _n.push(obj);

        });


        // Check if builtin or custom


        let _obj = {
            menu_id: _menu_item.id,
            new_tab: _menu_item.new_tab,
            name: _menu_item.name,
            visibility: _menu_item.visibility,
            parent_id: _menu_item.parent_id,
            url: _menu_item.url,
            order: _menu_item.order,
        }

        if (!_menu_item.parent_id) {
            delete _obj.parent_id;
        }

        // ensure url is empty string if falsey or string null
        if (!_obj.url || _obj.url === "null") {
            _obj.url = "";
        }

        apiCall("site_content/updateMenu", _obj, (_status, _result) => {
            if (_status) {
                setMenus(_result)
            } else {
                message.error(_result.error);
                setMenus(_og_nav);
            }
        })
    }

    const drawLabel = (_item, _children) => {


        return <PageRow children={_children} setToOpenPage={setToOpenPage} setPage={setPage} menus={menus} setMenus={setMenus} page={_item} />;

        return (
            <span style={{ "opacity": (_item.visibility === "visible") ? "1" : "0.6" }}>
                {_item.name}&nbsp;
                {((_item.visibility === "hidden") && <Tooltip title={<small>Hidden</small>}><EyeInvisibleOutlined style={{ "fontSize": "11px" }} /></Tooltip>)}
                {((_item.visibility === "test") && <Tooltip title={<small>Test</small>}><DisconnectOutlined style={{ "fontSize": "11px" }} /></Tooltip>)}
            </span>
        )
    }



    const parseMenu = () => {
        let ret = [...menus];


        let rtrn = ret.filter(item => !item.parent_id).map(item => {

            let ret = { ...item }
            ret.title = <div>
                {drawLabel(item, menus.filter(ch => ch.parent_id === ret.id))}
            </div>;
            ret.key = ret.id;
            ret.className = item.visibility;
            ret.icon = drawIcon(ret);

            ret.children = menus.filter(ch => ch.parent_id === ret.id).map(i => {
                i.children = [];
                i.title = <div>
                    {drawLabel(i)}
                </div>;
                i.icon = drawIcon(i);
                i.key = i.id;
                return i;
            });
            return ret;
        })

        setNav(rtrn);

    }


    useEffect(parseMenu, [menus])

    const [nav, setNav] = useState([]);



    const onDrop = (info) => {

        let confirm = { type: "" }
        let og_nav = [...menus];
        const dropKey = info.node.key;
        const dragKey = info.dragNode.key;
        const dropPos = info.node.pos.split('-');
        const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

        // Disable nesting more than 1 level
        if (dropPos.length > 2 && !info.dropToGap) {
            message.error("Can't nest pages more than 1 level")
            return false;
        }
        // Disable nesting menu items that have children
        if (!info.dropToGap && info.dragNode.children.length > 0) {
            message.error("Can't nest pages that have sub-pages")
            return false;
        }

        // Disable nesting built-in menus
        if (!info.dropToGap && info.dragNode.can_delete === false) {
            // message.error("Can't nest built-in pages")
            //return false; 
        }

        // Warn when nesting into a top-level that has content (first child only)
        if (!info.dropToGap && info.node.has_content && info.node.children.length === 0) {
            confirm.type = "nesting";
            confirm.parent = info.node;
            confirm.child = info.dragNode;
        }


        const loop = (data, key, callback) => {
            for (let i = 0; i < data.length; i++) {
                if (data[i].key === key) {
                    return callback(data[i], i, data);
                }

                if (data[i].children) {
                    loop(data[i].children, key, callback);
                }
            }
        };

        const data = [...nav];

        let dragObj;
        loop(data, dragKey, (item, index, arr) => {
            arr.splice(index, 1);
            dragObj = item;
        });

        if (!info.dropToGap) {
            loop(data, dropKey, (item) => {
                item.children = item.children || [];
                item.children.unshift(dragObj);
            });
        } else if (
            (info.node.props.children || []).length > 0 &&
            info.node.props.expanded &&
            dropPosition === 1
        ) {
            loop(data, dropKey, (item) => {
                item.children = item.children || [];
                item.children.unshift(dragObj);
            });
        } else {
            let ar = [];
            let i;
            loop(data, dropKey, (_item, index, arr) => {
                ar = arr;
                i = index;
            });

            if (dropPosition === -1) {
                ar.splice(i, 0, dragObj);
            } else {
                ar.splice(i + 1, 0, dragObj);
            }
        }




        if (confirm.type === "nesting") {
            Modal.confirm({
                title: "Heads up!",
                content: <>
                    The menu <strong>{confirm.parent.name}</strong> you are putting this under has content. That content will become inaccessible on the customer site. <br /><br />Are you sure you want to continue?
                </>,
                onOk: () => {
                    updateMenu(data, info.dragNode.id, og_nav);
                    setNav(data);
                }
            })
        } else {
            updateMenu(data, info.dragNode.id, og_nav);
            setNav(data);
        }


    };



    const drawFilter = () => {

        const content = (
            <>
                <div><small style={{ "color": "#1890ff" }}>FILTER PAGES</small></div>
                <div className="shim" /><div className="shim" />
                <Space direction="vertical">
                    <Checkbox onChange={(e) => setFilters({ ...filters, "test": !e.target.checked })} checked={!filters.test}><div style={{ "color": orange_color, "display": "flex", "alignItems": "center" }}>
                        <EyeSlashIcon style={{ "color": "#e77e21" }} />&nbsp; Draft</div>
                    </Checkbox>
                    <Checkbox onChange={(e) => setFilters({ ...filters, "visible": !e.target.checked })} checked={!filters.visible}><div style={{ "color": green_color, "display": "flex", "alignItems": "center" }}>
                        <EyeIcon style={{ "color": "#3c8617" }} />&nbsp; Visible</div>
                    </Checkbox>
                    <Checkbox onChange={(e) => setFilters({ ...filters, "hidden": !e.target.checked })} checked={!filters.hidden}><div style={{ "color": purple_color, "display": "flex", "alignItems": "center" }}>
                        <EyeIcon style={{ "color": "#aa119d" }} />&nbsp; Unlisted</div>
                    </Checkbox>
                </Space>
            </>
        );

        return (
            <Popover placement="bottomRight" title={false} content={content} trigger="click">
                <Button size="small" type="text" icon={<Badge color="blue" offset={[2, 5]} dot={(filters.hidden || filters.visible || filters.test)}>
                    <Tooltip title={tt_menu_filter}>
                        <FilterIcon style={{ "width": "9px", "fill": "#a1a1a1", "margin": "0 auto" }} />
                    </Tooltip>
                </Badge>} />
            </Popover>
        )
    }

    const shrink = () => {
        let ret = ""
        if (filters.hidden) {
            ret += "hide-hidden "
        }

        if (filters.visible) {
            ret += "hide-visible "
        }

        if (filters.test) {
            ret += "hide-test "
        }

        if (highlight) {
            ret += " new-highlight"
        }

        return ret;
    }


    const toggleHighlight = () => {
        setHighlight(true);
        setTimeout(() => {
            setHighlight(false);
        }, 3000)
    }

    return (
        <>
            <div style={{ "padding": "15px", "paddingTop": "0px" }}>
                <div className="float-flex" style={{ "padding": "0px 0px" }}>
                    <Overlay width={500} component={<MenuEdit menus={menus} is_new={true} toggleHighlight={toggleHighlight} setToOpenPage={setToOpenPage} setPage={setPage} setMenus={setMenus} selectEdit={selectEdit} setSelectEdit={setSelectEdit} visible={visible} setVisible={setVisible} />}>
                        <Button onClick={() => {
                            setSelectEdit({ can_delete: true, order: 0 })
                            setVisible(true);
                        }} type="link" icon={<PlusIcon />} size="small" ><small>&nbsp; Add new page / menu</small></Button>
                    </Overlay>
                    {drawFilter()}
                </div>
            </div>
            <Divider style={{ "margin": "0px 0px", "borderColor": "#d9d9d9" }} />
            <div style={{ "padding": "15px", "paddingTop": "0px" }}>
                <div className="shim" /><div className="shim" /><div className="shim" />

                <Alert type="info" style={{ "marginBottom": "15px" }} closable message={<small>Click and drag to change the order of menus. Drag a menu on top of and then to the right of another menu to make it into a sub menu. Click a menu name to load the list of content under that menu.</small>} />


                <div style={{ "fontSize": "8px" }} className="float-flex">
                    <div style={{ "opacity": "0.8" }}>SITE NAVIGATION</div>
                    <Tooltip title={tt_not_activated}><div style={{"cursor" : "default"}}><span style={{ "color": "#c94646" }}>*</span> <span style={{ "opacity": "0.8" }}>Not activated</span> </div></Tooltip>
                </div>
                <div className="shim" /><div className="shim" />


                <Tree
                    style={{ "marginLeft": "-5px" }}
                    draggable
                    blockNode
                    className={shrink()}
                    onSelect={(_selectedKeys, _node) => {
                        let _f = menus.find(item => item.id === _selectedKeys[0]);
                        if (_f) {
                            setPage(_f);
                        }
                        setOpen(true);
                    }}
                    onDrop={(e) => onDrop(e)}
                    selectedKeys={[page.id]}
                    // checkable
                    // defaultExpandedKeys={['0-0-0', '0-0-1']}
                    // defaultSelectedKeys={['0-0-0', '0-0-1']}
                    // defaultCheckedKeys={['0-0-0', '0-0-1']}
                    // onSelect={onSelect}
                    // onCheck={onCheck}
                    treeData={nav}
                />

                <TrashedMenus nav={nav} parseMenu={parseMenu} setMenus={setMenus} setNav={setNav} menus={menus} />

            </div>
            <Divider style={{ "margin": "0px 0px", "borderColor": "#d9d9d9" }} />
            <div style={{ "padding": "15px", "paddingTop": "0px" }}>
                <div className="shim" /><div className="shim" /><div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">STATIC COMPONENTS</Divider>
                <div className="shim" /><div className="shim" />
                <GlobalContent selected={selected} setSelected={setSelected} />
                <div className="shim" /><div className="shim" /> <div className="shim" /><div className="shim" />


            </div >

        </>
    )

}